import { render, staticRenderFns } from "./chatMessageView.vue?vue&type=template&id=5543bb41&scoped=true"
import script from "./chatMessageView.vue?vue&type=script&lang=js"
export * from "./chatMessageView.vue?vue&type=script&lang=js"
import style0 from "./chatMessageView.vue?vue&type=style&index=0&id=5543bb41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5543bb41",
  null
  
)

export default component.exports